var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-documento',{key:_vm.$root.$session.versao,attrs:{"intCadastroGeralEmpresaId":0,"intTipoDocumentoId":280,"intTipoRevisaoId":285}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }